import createIcon from '../../createIcon';

/**
 * @component @name QueuePlayNext
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSAyLjI1SDIuNUMxLjM5IDIuMjUgMC41IDMuMTQgMC41IDQuMjVWMTYuMjVDMC41IDE3LjM1IDEuMzkgMTguMjUgMi41IDE4LjI1SDcuNVYyMC4yNUgxNS41VjE4LjI1SDE3LjVWMTYuMjVIMi41VjQuMjVIMjAuNVYxMi4yNUgyMi41VjQuMjVDMjIuNSAzLjE0IDIxLjYgMi4yNSAyMC41IDIuMjVaTTEyLjUgOS4yNVY2LjI1SDEwLjVWOS4yNUg3LjVWMTEuMjVIMTAuNVYxNC4yNUgxMi41VjExLjI1SDE1LjVWOS4yNUgxMi41Wk0yMy41IDE3LjI1TDE5IDIxLjc1TDE3LjUgMjAuMjVMMjAuNSAxNy4yNUwxNy41IDE0LjI1TDE5IDEyLjc1TDIzLjUgMTcuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const QueuePlayNext = createIcon('QueuePlayNext', [
  [
    'path',
    {
      d: 'M20.5 2.25H2.5C1.39 2.25 0.5 3.14 0.5 4.25V16.25C0.5 17.35 1.39 18.25 2.5 18.25H7.5V20.25H15.5V18.25H17.5V16.25H2.5V4.25H20.5V12.25H22.5V4.25C22.5 3.14 21.6 2.25 20.5 2.25ZM12.5 9.25V6.25H10.5V9.25H7.5V11.25H10.5V14.25H12.5V11.25H15.5V9.25H12.5ZM23.5 17.25L19 21.75L17.5 20.25L20.5 17.25L17.5 14.25L19 12.75L23.5 17.25Z',
      key: 'cu2t9n',
    },
  ],
]);

export default QueuePlayNext;
